import script from "./donationConfirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./donationConfirmation.vue?vue&type=script&setup=true&lang=js"

import "./donationConfirmation.vue?vue&type=style&index=0&id=98c95946&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98c95946"]])

export default __exports__